import React from "react";
// mui
import { Card, Typography, Grid, Box } from "@mui/material";

export const WalletSummary = () => {
  const WalletIcon = "/Assets/Icons/wallet.svg";
  const DollarIcon = "/Assets/Icons/dollar.svg";
  const GiftIcon = "/Assets/Icons/gift.svg";
  const AwardIcon = "/Assets/Icons/award.svg";

  const rawData = [
    {
      id: 1,
      name: "Total Wallet Balance",
      amount: 0,
      icon: WalletIcon,
      type: "All Accounts",
      color: "#18DC8B",
    },
    {
      id: 2,
      name: "Available Balance",
      amount: 0,
      icon: DollarIcon,
      type: "Ready to Use",
      color: "#18DC8B",
    },
    {
      id: 3,
      name: "Pending Withdrawals",
      amount: 0,
      icon: GiftIcon,
      type: "Processing",
      color: "#EB4747",
    },
    {
      id: 4,
      name: "Pending Deposits",
      amount: 0,
      icon: AwardIcon,
      type: "In Progress",
      color: "#EB4747",
    },
  ];
  return (
    <React.Fragment>
      <Typography
        gutterBottom
        variant="h5"
        component="div"
        sx={{
          fontSize: 22,
          fontWeight: 500,
          color: "#FFF",
          mt: 2,
        }}
      >
        Wallet Summary
      </Typography>
      <Grid container spacing={2}>
        {rawData?.map((item) => (
          <Grid item xs={12} sm={6} md={3} key={item?.id}>
            <Card
              sx={{
                backgroundColor: "#242424",
                color: "white",
                padding: 2,
                borderRadius: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                border: "1px solid rgba(255, 224, 51, 0.20)",
              }}
            >
              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{ color: "#FFD700", fontWeight: 600, fontSize: 14 }}
                >
                  {item?.name}
                </Typography>
                <Typography
                  variant="h4"
                  sx={{ fontWeight: 400, mt: 1, fontSize: 24 }}
                >
                  {item?.amount}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 400,
                    color: item?.color,
                    mt: 1,
                    fontSize: 14,
                  }}
                >
                  {item?.type}
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: "rgba(255, 215, 0, 0.20)",
                  padding: 1,
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={item?.icon}
                  alt={item?.name}
                  style={{ width: 24, height: 24 }}
                />
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </React.Fragment>
  );
};
